import Alert from 'react-s-alert';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { push } from 'react-router-redux';
import UsersRequest from '../ws/UsersRequest';
import UserRequest from '../ws/UserRequest';
import AddUserRequest from '../ws/AddUserRequest';
import { PsRoutes } from '../../shared/routing/Routes';
import UserRolesRequest from '../ws/UserRolesRequest';
import UpdateUserRequest from '../ws/UpdateUserRequest';

export const USER_UPDATE = 'user-update';
export const USERS_UPDATE = 'users-update';
export const USERS_LOADING = 'users-loading';
export const USERS_ERROR = 'users-error';

export const USER_LOADING = 'user-loading';

export const USER_ROLES_UPDATE = 'user-roles-update';

export const getUsers = (page = 1, search = '', filter = 0) => (dispatch) => {

    new UsersRequest(page, search, filter)
        .onPreExecution(() => {
            dispatch({ type: USERS_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: USERS_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: USERS_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: USERS_LOADING, payload: false });
        })
        .execute();
};

export const getUser = (id) => (dispatch) => {

    new UserRequest(id)
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: USER_UPDATE,
                payload: data,
            });
        })
        .execute();
};

export const getUserRoles = () => (dispatch) => {

    new UserRolesRequest()
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: USER_ROLES_UPDATE,
                payload: response,
            });
        })
        .execute();
};

export const addUser = (user = {}) => (dispatch) => {

    new AddUserRequest(user)
        .onPreExecution(() => {
            dispatch({ type: USER_LOADING, payload: true });
        })
        .onSuccess(data => {
            Alert.success(I18nUtils.tr('TR_ADD_USER_SUCCESS'));
            dispatch(push(PsRoutes.USERS));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_ADD_USER_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: USER_LOADING, payload: false });
        })
        .execute();
};

export const updateUser = (user = {}, updateUserRoleId = false) => (dispatch) => {
    new UpdateUserRequest(user.id, user)
        .onPreExecution(() => {
            dispatch({ type: USER_LOADING, payload: true });
        })
        .onSuccess(data => {
            let successMessage = I18nUtils.tr('TR_UPDATE_USER_SUCCESS');
            if (updateUserRoleId) {
                successMessage += I18nUtils.tr("TR_SE_HA_ACTUALIZADO_EL_ROL_INDICA_AL_USUARIO_QUE_CIERRE_LA_SESION");
            }
            Alert.success(successMessage);
            dispatch(push(PsRoutes.USERS));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_UPDATE_USER_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: USER_LOADING, payload: false });
        })
        .execute();
};



// WEBPACK FOOTER //
// ./src/app/users/actions/userActions.js